import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '@/components/ui/dialog'
import ConfirmationDialog from '@/components/common/ConfirmationDialog'
import VideoThumbnailEditor from '@/components/mediaBuying/adCreatives/shared/VideoThumbnailEditor'

const CarouselDialogs = ({
    showDeleteDialog,
    cardToDelete,
    isDeleting,
    onCancelDelete,
    onConfirmDelete,
    showThumbnailEditor,
    selectedAsset,
    onCloseThumbnailEditor,
    onSelectionChange,
    onSaveThumbnail,
    currentSelection,
    uploadState,
}) => {
    return (
        <>
            <ConfirmationDialog
                isOpen={showDeleteDialog}
                onClose={onCancelDelete}
                onConfirm={onConfirmDelete}
                title="Delete Card"
                description={`Are you sure you want to delete "${cardToDelete?.name}"? This action cannot be undone.`}
                confirmText="Delete"
                cancelText="Cancel"
                variant="destructive"
                isProcessing={isDeleting}
            />

            <Dialog open={showThumbnailEditor} onOpenChange={onCloseThumbnailEditor}>
                <DialogContent className="tw:w-2xl tw:!p-0">
                    <DialogHeader>
                        <DialogTitle>Video Thumbnail Editor</DialogTitle>
                    </DialogHeader>
                    <DialogDescription className="tw:px-0">
                        <VideoThumbnailEditor onSelectionChange={onSelectionChange} adAsset={selectedAsset} />
                    </DialogDescription>
                    <DialogFooter>
                        <Button variant="secondary" className="tw:!w-40" onClick={onCloseThumbnailEditor}>
                            Cancel
                        </Button>
                        <Button
                            className="tw:!w-40"
                            onClick={onSaveThumbnail}
                            disabled={currentSelection?.mode === 'upload' && uploadState === 'uploading'}
                        >
                            Save
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CarouselDialogs
